<template>
  <div class="modal">
    <div class="empty" @click="$emit('close')"></div>
    <div class="box">
      <div class="close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></div>

      <div class="content">
        <div class="line"
             :class="{'efeit': info.cat_id === 1, 'cond': info.cat_id === 2, 'ativ': info.cat_id === 3, 'sel': info.cat_id === 4, 'tuto': info.cat_id === 5}"></div>
        <div class="top-con">
          <div class="image"></div>
          <div class="title">{{ info.wired }}</div>
          <div class="desc">{{ info.description }}</div>
        </div>
        <div class="text" v-html="info.text"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  obj: {
    type: Object,
    default: () => {
    }
  }
})
const info = ref(props.obj)

</script>

<style scoped>

.modal .box {
  position: relative;
  width: 740px;
  max-width: calc(100vw - 32px);
  height: 70%;
}

.modal .box .close {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 10px;
  left: 10px;
  z-index: 99;
}

.modal .content {
  position: relative;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 0;
  margin-top: 0;
}

.modal .content::-webkit-scrollbar {
  width: 5px;
}

/*noinspection ALL*/
.modal .content::-webkit-scrollbar-thumb {
  background-color: var(--color2);
  border-radius: 10px;
}


.modal .content .line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 60px;
  height: 4px;
  border-radius: 0 0 4px 4px;
  transform: translateX(-50%);
}

.modal .content .line.cond {
  background-color: #0D93C6;
}

.modal .content .line.efeit {
  background-color: #2FC145;
}

.modal .content .line.ativ {
  background-color: #e45bcd;
}

.modal .content .top-con {
  width: 100%;
  height: auto;
  border-bottom: 2px solid rgba(0, 0, 0, .08);
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;
}

.modal .content .top-con .image {
  width: 290px;
  height: 60px;
  background-image: url('../../assets/image1.png');
}

.modal .content .top-con .title,
.modal .content .top-con .desc {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
}

.modal .content .top-con .desc {
  font-weight: 400;
  font-size: 14px;
  margin-top: 6px;
}

.modal .content .text {
  width: 100%;
  height: auto;
  padding: 10px;
}

@media only screen and (max-width: 500px) {
  .modal .box {
    width: calc(100% - 10px);
  }
}
</style>